module.exports = __webpack_public_path__ + "09a448bc67b6af20fd6dfac23575e64f.png";